/**
 * @voltxampere/ui — LM386 audio amplifier (Sprint 45-2, placeholder)
 *
 * Reference: TI LM386 — DIP-8 / SOIC-8. Düşük güç tek-kanal audio
 * amp, batarya ile çalışır. V_supply 4-12 V, 0.5 W output @ 8 Ω,
 * gain 20-200 (eksternal R + C ile ayarlanır), THD <0.2 %, GBW
 * ~300 kHz. Hobbyist amplified speaker + intercom + radio
 * receiver klasik IC'si.
 *
 *   Default mapping → opamp schemaType:
 *     openLoopGain = 200       (gain x200 with C1 + R bypass)
 *     poleFrequency = 1500     (300 kHz / 200 GBW estimate)
 *     saturationVoltage = 6    (V_supply 12V için yarısı clip)
 *
 * Engine zero-diff invariant honored — canonical `opamp` engine
 * type via schemaType (Sprint 39 op-amp datasheet pattern reuse).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const audioLm386 = {
    id: "lm386",
    nameTr: "LM386 (Audio Amp 0.5W, DIP-8, placeholder)",
    nameEn: "LM386 (Audio Amp 0.5W, DIP-8, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "LM386",
    schemaType: "opamp",
    defaultParams: { openLoopGain: 200, poleFrequency: 1500, saturationVoltage: 6 },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=audio-lm386.js.map